import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {CompanyLabel} from '../../Enum/company-label.enum';
import {CompanyPeer} from '../../Enum/company-peer.enum';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  informationSelected: boolean;
  bwSummarySelected: boolean;
  mdSummarySelected: boolean;
  currentUser: UserLogged;
  hasMckayStatus: boolean;
  hasQuincyStatus: boolean;
  isExpiredNDA = false;

  constructor(private route: ActivatedRoute,
              public utilsService: UtilsService,
              public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.informationSelected = true;
    this.bwSummarySelected = false;
    this.mdSummarySelected = false;
    this.currentUser = this.authenticationService.getUserCurrent();
    if (this.currentUser) {
      this.hasMckayStatus = this.calculateHasMckayStatus();
      this.hasQuincyStatus = this.calculateHasQuincyStatus();
      this.route.paramMap.subscribe(params => {
        const adminUniqid = params.get('admin');
        const currentCompanyUniqId = params.get('currentCompanyUniqId');
        if (![currentCompanyUniqId, adminUniqid].includes(this.currentUser.company.uniqid)) {
          const userAuthenticated = (this.currentUser.company.uniqid === 'admin') ? 'mckay' : 'client';
          location.assign('/#/' + userAuthenticated + '/' + this.currentUser.company.uniqid);
        }
      });
      this.isExpiredNDA = !this.currentUser.permissions.isMckayUser
        && this.currentUser.permissions.isAdminOrSuperUser
        && !this.currentUser.permissions.hasNotExpiredNda;
    }
  }

  onChange(event) {
    if (event.index === 0) {
      this.informationSelected = true;
      this.bwSummarySelected = false;
      this.mdSummarySelected = false;
    } else if (event.index === 1) {
      if (this.hasMckayStatus) {
        this.informationSelected = false;
        this.bwSummarySelected = true;
        this.mdSummarySelected = false;
      } else if (this.hasQuincyStatus) {
        this.informationSelected = false;
        this.bwSummarySelected = false;
        this.mdSummarySelected = true;
      }
    } else if (event.index === 2) {
      this.informationSelected = false;
      this.bwSummarySelected = false;
      this.mdSummarySelected = true;
    }
  }

  calculateHasMckayStatus() {
    return (this.currentUser.company.label === CompanyLabel.LABEL_MCKAY
        || this.currentUser.company.label === CompanyLabel.LABEL_ALL)
      && (this.currentUser.company.sugarMckayStatus === CompanyPeer.SUGAR_CUSTOMER_STATUS
        || this.currentUser.company.sugarMckayStatus === CompanyPeer.SUGAR_ONBOARDING_STATUS);
  }

  calculateHasQuincyStatus() {
    return (this.currentUser.company.label === CompanyLabel.LABEL_QUINCY
        || this.currentUser.company.label === CompanyLabel.LABEL_ALL)
      && (this.currentUser.company.sugarQuincyStatus === CompanyPeer.SUGAR_CUSTOMER_STATUS
        || this.currentUser.company.sugarQuincyStatus === CompanyPeer.SUGAR_ONBOARDING_STATUS);
  }
}
